export default __webpack_public_path__ + "static/media/sirohi.846b6851.png";